module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.recreating) ? _c('div', {
    staticClass: "form-flex"
  }, [_c('date-picker', {
    attrs: {
      "disabled": _vm.disabled,
      "options": _vm.options
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), (_vm.isCleanable) ? _c('a', {
    staticClass: "form-addon btn btn--default",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "icon-eraser"
  })]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa5e152e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/DateInput.vue
// module id = 3504
// module chunks = 0